var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJunctionWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 705,
    height: 212,
    viewBox: "0 0 705 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.9 130.4C364.9 135.9 360.5 140.3 355 140.3H315.2C309.7 140.3 305.3 135.9 305.3 130.4V80.9C305.3 75.4 309.7 71 315.2 71H355C360.5 71 364.9 75.4 364.9 80.9V90.7H353.6V81H316.9V130.6H353.6V120.6H364.9V130.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M475.3 140.3H464V71H475.3V140.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M550.1 140.3H510.6C505.1 140.3 500.7 135.9 500.7 130.4V80.9C500.7 75.4 505.1 71 510.6 71H550.1C555.6 71 560 75.4 560 80.9V130.4C560 135.9 555.6 140.3 550.1 140.3ZM548.7 130.6V81H512V130.6H548.7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3001 71V130.5H70.6V120.5H59.3V130.3C59.4 135.7 63.8 140 69.2 140.1H98.8001C101.6 140 104.1 138.7 105.9 136.6C107.6 134.9 108.6 132.6 108.7 130.2V71H97.3001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.1 71V130.3H146.4V71H135.1V130.4C135.1 135.9 139.5 140.3 145 140.3H194.4V71H183.1Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M439.1 71H386.9H385.6V81H386.9H407.3V140.3H418.6V81H439.1H440.4V71H439.1Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.6 70.9969V122.497V129.497H267.2L240.5 70.7969H231.9H220.6V97.4969V140.297H231.9V97.4969V88.5969V81.4969H233.3L260.1 140.297H268.6H279.9V70.9969H268.6Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M633.7 70.9969V122.497V129.497H632.3L605.6 70.7969H597H585.7V97.4969V140.297H597V97.4969V88.5969V81.4969H598.4L625.2 140.297H633.7H645V70.9969H633.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunctionWordmark);
export default __webpack_public_path__ + "static/media/junction_wordmark.0c8702738e55f955bce4ea52f121b93c.svg";
export { ForwardRef as ReactComponent };